__turbopack_context__.v({
  "fields": "repowering-form-module__KAXuDG__fields",
  "repowering-form": "repowering-form-module__KAXuDG__repowering-form",
});
